import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

export class EnvironmentService {
  static environment: any;
  static API_URLS: any;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ]
})
export class ServiceModule {
  public static forRoot(_environment: any, _API_URLS?: any): ModuleWithProviders<ServiceModule> {
    EnvironmentService.environment = _environment;
    EnvironmentService.API_URLS = _API_URLS;
    return { ngModule: ServiceModule, providers: [] };
  }
}
